type Product = {
  containerID: string
  sku: string
  isMainVariant: boolean
}

function getProductLink(product: Product, noLink?: false | undefined): string
function getProductLink(product: Product, noLink?: boolean): undefined

function getProductLink(
  product: Product,
  noLink?: boolean
): string | undefined {
  if (noLink) return undefined
  return `/pdp/${product.containerID}/${
    product.isMainVariant ? '' : `?sku=${product.sku}`
  }`
}

export default getProductLink
